import { render, staticRenderFns } from "./table-row.vue?vue&type=template&id=b0038b32&scoped=true&"
import script from "./table-row.vue?vue&type=script&lang=js&"
export * from "./table-row.vue?vue&type=script&lang=js&"
import style0 from "./table-row.vue?vue&type=style&index=0&id=b0038b32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0038b32",
  null
  
)

export default component.exports